import React from 'react';
import TextInput from './TextInput';
import { Controller, useFormState } from 'react-hook-form';
import { get as getError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const TextInputController = ({
  control,
  name,
  ...rest
}) => {
  const [t] = useTranslation();
  const { errors } = useFormState({ control });
  const error = getError(errors, name);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <TextInput {...field} {...rest} error={t(error?.message)} />
      )}
    />
  )
};

export default TextInputController;
